import { Navigate } from 'react-router-dom'
import { useCloudContext } from '../contexts/CloudProvider.jsx'
import { useAccessData } from '../hooks/useAccessData.js'
import LoadingSpinner from '../components/LoadingSpinner.jsx'
import OnboardingHero from '../components/OnboardingHero.jsx'
import InvitationView from '../components/InvitationView.jsx'

/**
 * HomePage - Main landing page that handles user state routing
 * 
 * Routes users to appropriate experience based on their state:
 * - Loading: Show spinner while checking devices/invitations
 * - No devices + Has invitations: Show invitation acceptance UI
 * - No devices + No invitations: Show onboarding hero
 * - Has devices: Redirect to dashboard
 */
function HomePage() {
  const { hasDevices, devicesLoading } = useCloudContext()
  const { useUserInvitations } = useAccessData()
  const { data: invitations = [], isLoading: invitationsLoading } = useUserInvitations()

  console.error('DEBUG: HomePage rendered, hasDevices:', hasDevices, 'URL:', window.location.href)

  // Show loading while checking devices/invitations
  if (devicesLoading || invitationsLoading) {
    return <LoadingSpinner message="Loading your devices..." />
  }

  // Has pending invitations - show invitation screen (highest priority)
  if (!hasDevices && invitations.length > 0) {
    return <InvitationView invitations={invitations} />
  }

  // No devices - show onboarding
  if (!hasDevices) {
    return <OnboardingHero />
  }

  // Has devices - go to dashboard
  return <Navigate to="/dashboard" replace />
}

export default HomePage
